import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4426ca3a")
const _hoisted_1 = { id: "shapes-component" }
const _hoisted_2 = {
  key: 0,
  id: "shapes-wrap"
}
const _hoisted_3 = { id: "columns-wrap" }
const _hoisted_4 = { id: "left-column" }
const _hoisted_5 = ["name", "src"]
const _hoisted_6 = { id: "right-column" }
const _hoisted_7 = ["name", "src"]
_popScopeId()

import { onBeforeMount, onMounted, ref, computed, watch } from "vue";
import { fabric } from "fabric";
import { store } from "@/store";
import { makeNewShape } from "@/canvas-api/UserObjects/SvgShape";
import canvasShapes from "@/data/shapes.json";

import ToolTitle from "./ToolTitle.vue";
import Customize from "./Customize.vue";

interface ShapeSVG {
  title: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// Vue 3.2 script setup api
const title = ref("Shapes");
const shapes = ref([] as ShapeSVG[]);

onBeforeMount(() => {
  shapes.value = canvasShapes["shapes"];
})

onMounted(() => {
  if (currentActiveObject.value && currentActiveObject.value.name === "svgShape")
    title.value = "Customize";
  else title.value = "Shapes";
})

const leftColumn = computed<ShapeSVG[]>(() => shapes.value.slice(0, shapes.value.length / 2))
const rightColumn = computed<ShapeSVG[]>(() => shapes.value.slice(shapes.value.length / 2))
const currentActiveObject = computed<fabric.Object | undefined>(() => store.getters.currentActiveObject)

watch(currentActiveObject, () => {
  if (currentActiveObject.value) title.value = "Customize";
  else title.value = "Shapes";
})

const addNewShape = (e: { target: HTMLInputElement }): void => {
  makeNewShape(e.target.src);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ToolTitle, { title: title.value }, null, 8, ["title"]),
    (!_unref(currentActiveObject) || _unref(currentActiveObject).name !== 'svgShape')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftColumn), (shape, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "shape-svg",
                  key: idx,
                  onClick: addNewShape
                }, [
                  _createElementVNode("img", {
                    name: shape.name,
                    src: require(`@/assets/canvas_shapes/${shape.name}.svg`)
                  }, null, 8, _hoisted_5)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightColumn), (shape, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "shape-svg",
                  key: idx,
                  onClick: addNewShape
                }, [
                  _createElementVNode("img", {
                    name: shape.name,
                    src: require(`@/assets/canvas_shapes/${shape.name}.svg`)
                  }, null, 8, _hoisted_7)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(Customize, { key: 1 }))
  ]))
}
}

})